module.exports = __webpack_public_path__ + "img/jypsmzf.e0c82a38.jpg";